export default "__VITE_ASSET__mrQM1Dky__"